import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { IconNameT } from '@/components/common/Icon.tsx'
import somethingWrong from '@/lib/helpers/somethingWrong.ts'
import { NavigationItemT } from '@/lib/types/navigationTypes.ts'

export type LocallyStoredFilterT = {
  pathname: string
  projectStageId: string
  name: string
  iconName: IconNameT | null
  id: string
  userId: number
  issueTypeId?: string
  projectStageIssuesLinks: NavigationItemT[]
}

type LocallyStoredFiltersT = {
  tabs: LocallyStoredFilterT[]
  setTabs: (tabs: LocallyStoredFilterT[]) => void
  activeTabId: string
  setActiveTabId: (activeTabId: string) => void
  addTab: (newTab: LocallyStoredFilterT) => void
  addFirstTab: (newTab: LocallyStoredFilterT) => void
  removeTab: (id: string) => void
  updateTabHref: (href: string) => void
  updateActiveTab: (updatedTab: LocallyStoredFilterT) => void
  updateProjectStageIssuesLinks: (projectStageIssuesLinks: NavigationItemT[]) => void
  // initialIssuesLoadDone: boolean
  // setInitialIssuesLoadDone: (initialIssuesLoadDone: boolean) => void
}

export const useLocallyStoredFilters = create(
  persist<LocallyStoredFiltersT>(
    set => ({
      updateProjectStageIssuesLinks: (projectStageIssuesLinks: NavigationItemT[]) =>
        set(state => {
          const index = state.tabs?.findIndex(tab => tab.id === state.activeTabId)
          if (index === -1) {
            somethingWrong(`no active tab found`)
            return state
          }
          const updated = [...state.tabs]
          updated[index].projectStageIssuesLinks = projectStageIssuesLinks
          // console.log(`updating active tab`)
          return { tabs: updated }
        }),
      tabs: [],
      activeTabId: '',
      setTabs: tabs => set({ tabs }),
      setActiveTabId: activeTabId => set({ activeTabId }),
      addFirstTab: newT =>
        set(() => {
          return {
            activeTabId: newT.id,
            tabs: [newT],
          }
        }),
      addTab: newT =>
        set(state => {
          // console.log(`adding tab to local storage, before:`, state.tabs)
          // add unique id
          const newTab = {
            ...newT,
            id: new Date().getTime().toString(),
          }
          // console.log(`adding tab to local storage, after: `, [...state.tabs, newTab])

          return { tabs: [...state.tabs, newTab], activeTabId: newTab.id }
        }),
      removeTab: id =>
        set(state => {
          // console.log('removing tab from local storage ❌, before:', state.tabs)
          // const removedTabIndex = state.tabs.findIndex(t => t.id === id)
          // const tabToActivateIndex = removedTabIndex > 0 ? removedTabIndex - 1 : 0
          const filtered = state.tabs.filter(tab => tab.id !== id)
          // console.log('removing tab from local storage ❌, after:', filtered)

          return { tabs: filtered }
        }),
      updateTabHref: (href: string) =>
        set(state => {
          const index = state.tabs?.findIndex(tab => tab.id === state.activeTabId)
          if (index === -1 || state.tabs[index].pathname === href) {
            return state
          }
          const updated = [...state.tabs]
          updated[index].pathname = href
          // console.log(`updating tab href`)
          return { tabs: updated }
        }),
      updateActiveTab: (updatedTab: LocallyStoredFilterT) =>
        set(state => {
          updatedTab.id = state.activeTabId
          // console.log(state.tabs, 'state.tabs')
          // console.log(state.activeTabId, 'state.activeTabId')
          const index = state.tabs?.findIndex(tab => tab.id === state.activeTabId)
          if (index === -1) {
            somethingWrong(`no active tab found`)
            return state
          }
          const updated = [...state.tabs]
          updated[index] = updatedTab
          // console.log(`updating active tab`)
          return { tabs: updated }
        }),
    }),
    { name: 'project-stage-tabs-storage' },
  ),
)
